import { render } from "./eventsTab.vue?vue&type=template&id=f33366c0&scoped=true"
import script from "./eventsTab.vue?vue&type=script&lang=ts"
export * from "./eventsTab.vue?vue&type=script&lang=ts"

import "./eventsTab.vue?vue&type=style&index=0&id=f33366c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f33366c0"

export default script